export const ACTIVE_GLOBAL_FILTER_KEY: string = 'applied-global-filter';
export const SAVED_FILTERS_KEY: string = 'saved_filters';
